/* eslint no-nested-ternary: "off" */
import * as React from 'react'
import NoData from '@App/components/blocks/NoData'
import TableHeader from './TableHeader'
import TableBody from './TableBody'

import './style.scss'

const Table = (props: any) => {
  const { header, body, data, sort, saveSortData, hideNoData } = props

  return (
    <div className="table">
      <TableHeader
        sort={sort}
        saveSortData={saveSortData}
        header={header}
        {...props}
      />
      {data && data.length ? (
        <TableBody body={body} data={data} {...props} />
      ) : (
          !hideNoData && <NoData />
        )}
    </div>
  )
}

export default Table
